/*
  <kg-more>: kuerzt einen Textblock auf wenige Zeilen und haengt „mehr lesen“ an.
  Ohne dieses Skript steht der ganze Text da, das Kuerzen ist nur eine Zugabe.
*/

class KgMore extends HTMLElement {
  connectedCallback() {
    this.inhalt = this.firstElementChild;
    if (!this.inhalt) return;
    this.knopf = document.createElement('button');
    this.knopf.type = 'button';
    this.knopf.className = 'more__toggle';
    this.knopf.textContent = this.dataset.more || '';
    this.knopf.addEventListener('click', () => this.umschalten());
    this.append(this.knopf);
    this.pruefen();
    this.beobachter = new ResizeObserver(() => this.pruefen());
    this.beobachter.observe(this.inhalt);
  }

  disconnectedCallback() {
    this.beobachter?.disconnect();
  }

  /* Der Knopf erscheint nur, wenn wirklich etwas abgeschnitten ist */
  pruefen() {
    if (this.hasAttribute('data-open')) return;
    const gekuerzt = this.inhalt.scrollHeight - this.inhalt.clientHeight > 4;
    this.toggleAttribute('data-truncated', gekuerzt);
    this.knopf.hidden = !gekuerzt;
  }

  umschalten() {
    const offen = this.toggleAttribute('data-open');
    this.knopf.textContent = (offen ? this.dataset.less : this.dataset.more) || '';
    if (!offen) this.pruefen();
  }
}

customElements.define('kg-more', KgMore);
